import jQuery from 'jquery'

jQuery(() => {
  const stackedPills = '.stacked-navigation .nav-tabs .nav-item'
  const numberOfSelectors = jQuery(`${stackedPills}.selector`).length

  // If there are more than 5 selectors, collapse all after the first 4 and activate a "More" button
  // that will reveal them.
  // There is no option to re-collapse after expanding; the idea is that the user will choose one of the selectors to click
  // on at that point.
  if (numberOfSelectors > 5) {
    jQuery(`${stackedPills}.selector:nth-child(n+5):not(.active)`).addClass('d-none d-md-block')
    jQuery(`${stackedPills}.more`).removeClass('d-none').addClass('d-block d-md-none')

    jQuery(`${stackedPills}.more a`).on('click', () => {
      jQuery(`${stackedPills}.selector`).removeClass('d-none').addClass('d-block')
      jQuery(`${stackedPills}.more`).removeClass('d-block').addClass('d-none')
    })
  }
})
